import React, { Component } from "react";
import { graphql } from "react-apollo";
import { queryGetCustomerFieldType } from "Apollo";
import Row from "./RowWithMutation";

export default graphql(queryGetCustomerFieldType)(
  class List extends Component {
    render() {
      const getCustomerFieldType = this.props.data.getCustomerFieldType;
      const list = getCustomerFieldType ? getCustomerFieldType : [];
      const renders = list.map((row, index) => (
        <Row
          key={row.id}
          id={row.id}
          index={index + 1}
          field={row.displayName}
        />
      ));
      return renders;
    }
  }
);



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/customer-field-panel/ListWithQuery.js